
export interface EscolaDTO {
  coop: string;
  id: number;
  nome: string;
}

export type ProgramaCheckedAno = {
  disabled: boolean,
  checked: boolean;
  anoImplementacao: string;
};

export enum ProgramaKey {
  A_UNIAO_FAZ_A_VIDA = 0,
  COOPERATIVAS_ESCOLARES = 1,
  FINANCAS_NA_MOCHILA = 2,
}

export enum ProgramaDescricao {
  A_UNIAO_FAZ_A_VIDA = 'A União Faz a Vida',
  COOPERATIVAS_ESCOLARES = 'Cooperativas Escolares',
  FINANCAS_NA_MOCHILA = 'Finanças na Mochila',
}

export const ESCOLA_ETAPAS_PARAMS_URL = {
  CADASTRO: 'cadastro',
  DUPLICAR: 'duplicar',
  EDITAR: 'edicao',
  PERIODO_CADASTRO: 'periodo-cadastro'
};

export const CENTRALIZADO = 1;
export const UNIAO_FAZ_A_VIDA_VALOR = ProgramaKey.A_UNIAO_FAZ_A_VIDA;
export const allProgramas = () =>
  [
    {
      value: ProgramaKey.A_UNIAO_FAZ_A_VIDA,
      description: ProgramaDescricao.A_UNIAO_FAZ_A_VIDA,
    },
    {
      value: ProgramaKey.COOPERATIVAS_ESCOLARES,
      description: ProgramaDescricao.COOPERATIVAS_ESCOLARES,
    },
    {
      value: ProgramaKey.FINANCAS_NA_MOCHILA,
      description: ProgramaDescricao.FINANCAS_NA_MOCHILA,
    },
  ];
